<template>
	<ul class="k__menu" :id="nav_id" :name="name">
		<KMenuItem
			v-for="navItem in navItems"
			:key="navItem.id"
			:menu="navItem"
		/>
	</ul>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import axios from 'axios'
import base64 from '@utils/base64'

const props = defineProps({
	id: {
		type: [Number, String],
	},
	slug: {
		type: String,
	},
	menu: {
		type: Array,
	}
})

const navItems = ref([])
const name = ref(null)
const nav_id = ref(null)

onBeforeMount(async () => {
	function loadData(data) {
		name.value   = data.name
		nav_id.value = data.slug
		navItems.value  = data.items
	}

	if(props.menu) {

		if(typeof props.menu === 'string') {
			navItems.value = JSON.parse(props.menu)
		} else {

			navItems.value = props.menu
		}


		return false
	} else {
		let key = props.id || props.slug
		let storageKey = `menu-${key}`
		let menus

		if(localStorage.getItem(storageKey)) {
			menus = JSON.parse(localStorage.getItem(storageKey))

			loadData(menus)
		}

		if(!window.API) {
			return console.error('A variável window.API não foi definida')
		}

		const req = await axios.get(`${window.API}/menus/${props.id || props.slug}`)
		const res = await req.data

		loadData(res)


		localStorage.setItem(
			storageKey,
			JSON.stringify(res)
		)
	}

})

</script>
